import axios, { AxiosInstance } from "axios";

export class SkyTermsClient {
  private url: string;
  public client: AxiosInstance;

  constructor(url: string) {
    this.url = url;
    this.client = this.createClient();
  }

  public createClient() {
    const client = axios.create({
      baseURL: this.url,
    });

    client.defaults.headers["Content-Type"] = "application/json; charset=utf-8";
    client.defaults.headers.Accept = "application/json; charset=utf-8";

    return client;
  }

  public async getLastTermsAndConditions() {
    return await this.client.get("/v1/terms-and-conditions/latest");
  }

  public async getLastAcceptedTerms(userId: string) {
    return await this.client.get(`/v1/accepted-terms/${userId}`);
  }
}
